import React from "react";

interface PulseBadgeProps {
  count: number;
  className?: string;
}

export function PulseBadge({ count, className = "" }: PulseBadgeProps) {
  if (count === 0) return null;

  return (
    <div className={`relative ${className}`}>
      {/* Badge principal */}
      <div className="absolute -top-1 -right-1 min-w-[20px] h-5 bg-gradient-to-br from-red-500 to-red-600 text-white text-xs font-bold rounded-full flex items-center justify-center px-1.5 shadow-lg shadow-red-500/50 z-10 animate-bounce-subtle">
        {count > 9 ? '9+' : count}
      </div>
      
      {/* Effet de pulsation */}
      <div className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full animate-ping opacity-75"></div>
      
      {/* Cercle extérieur fixe */}
      <div className="absolute -top-1 -right-1 w-5 h-5 bg-red-500/30 rounded-full animate-pulse-slow"></div>

      <style>{`
        @keyframes bounce-subtle {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-2px);
          }
        }
        @keyframes pulse-slow {
          0%, 100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 0.1;
            transform: scale(1.2);
          }
        }
        .animate-bounce-subtle {
          animation: bounce-subtle 2s ease-in-out infinite;
        }
        .animate-pulse-slow {
          animation: pulse-slow 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
